// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import { StreamActions } from "@hotwired/turbo"
import * as ActiveStorage from "@rails/activestorage"
import "./controllers"
import "./turbo_native_bridge"
import "./native_outbox"
import "./service_worker_registration"

ActiveStorage.start()

// Custom Turbo Stream action to set data attributes on an element
// Usage: <%= turbo_stream.action :set_attribute, "element-id", attribute: "data-btn-feedback-triggered-value", value: "true" %>
StreamActions.set_attribute = function() {
  const target = document.getElementById(this.target)
  if (target) {
    const attribute = this.getAttribute("attribute")
    const value = this.getAttribute("value")
    target.setAttribute(attribute, value)
  }
}

// Animate Turbo Stream prepend/append actions
document.addEventListener("turbo:before-stream-render", (event) => {
  const stream = event.target
  const action = stream.getAttribute("action")

  if (!["prepend", "append", "before", "after"].includes(action)) return

  const firstChild = stream.firstElementChild?.content?.firstElementChild
  if (!firstChild) return

  event.preventDefault()
  firstChild.classList.add("animate-stream-in")
  stream.performAction()
})
